import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { BaseRouteEnum, OnboardingEnum } from '../enums/modules/routes'
import { ThirdPartyToolsManager } from '@/utils/thirdPartyToolsManager'

const OnboardingStoreModule = () =>
  import(/* webpackChunkName: "Onboarding" */ '../store/modules/onboarding')

const PricingStoreModule = () =>
  import(/* webpackChunkName: "Pricing" */ '../store/modules/pricing')

const Onboarding = () =>
  import(/* webpackChunkName: "Onboarding" */ '@/components/onboarding/Onboarding')

const dynamicModuleRegistrationOnboardingArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'onboarding',
    module: OnboardingStoreModule,
    store,
    modulePath: 'onboarding'
  }
}

const dynamicModuleRegistrationPricingArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'pricing',
    module: PricingStoreModule,
    store,
    modulePath: 'pricing'
  }
}

export default [
  {
    path: '/Onboarding',
    name: OnboardingEnum.Onboarding,
    component: Onboarding,
    async beforeEnter (_to, _from, next) {
      await DynamicModuleRegistrationUtil(dynamicModuleRegistrationOnboardingArgs())
      await DynamicModuleRegistrationUtil(dynamicModuleRegistrationPricingArgs())
      // Make sure that we disable the pendo guides.
      ThirdPartyToolsManager.disablePendoGuides()
      next()
    },
    meta: {showSideNav: false}
  }
]
